import { render } from "./StoreSettings.vue?vue&type=template&id=9644d2ac"
import script from "./StoreSettings.vue?vue&type=script&lang=js"
export * from "./StoreSettings.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__